<form name="GroupForm" (ngSubmit)="Validate(GroupForm)" #GroupForm="ngForm">
<div class="card">
    <div class="card-header">
      
            Group Master
       
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-12 px-1">
                <label class="form-font-label">Group Name</label>
                <input type="text" class="form-control" name="AssetGroupName" placeholder="Ex. Laptop"
                    [(ngModel)]="GroupDetail.AssetGroupName" #AssetGroupName="ngModel" required>
                <div class="invalid-feedback">
                    Please enter group name !
                </div>
            </div>
            <div class="col-md-12 px-1 pt-2">
                <label class="form-font-label">Group Code</label>
                <input type="text" class="form-control" name="AssetGroupCode" placeholder="Ex. Laptop"
                    [(ngModel)]="GroupDetail.AssetGroupCode" #AssetGroupCode="ngModel" required>
                <div class="invalid-feedback">
                    Please enter group name !
                </div>
            </div>


            <div class="col-md-12 px-1 pt-2">
                <label class="form-font-label">Description</label>
                <textarea rows=4 class="form-control" name="Description" [(ngModel)]="GroupDetail.Description"
                #Description="ngModel" required></textarea>
                <div class="invalid-feedback">
                    Please enter description !
                </div>

            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
             
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                    ngbTooltip="Cancel" container="body" placement="top">
                    Cancel
                    <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                </button>

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>

            </div>
        </div>
    </div>
</div>
</form>
